module.exports = __webpack_public_path__ + "static/stephani-bishop-katie-couric-bw-1db737dfd896cd38b01c5251d763ae08.jpg";